const Separator = () => {
  return <div className="border-t border-dashed border-dark-500"></div>;
};

export { Separator };
